module.exports = __webpack_public_path__ + "static/05-fd3f86da49074f9eddbbf2ca92ca151c.png";